import { Component, OnInit, Input } from "@angular/core";
import { ApiService } from "src/app/services/api.service";
import { UtilserviceService } from "src/app/services/utilservice.service";
import { ModalController, NavController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { jhcassoAPIUri } from "src/environments/apiUri";
import { CouponsInfoResponse } from "src/app/models/Response/CouponsResponse";
import { NavigationService } from "src/app/services/navigation.service";

@Component({
  selector: "app-coupon",
  templateUrl: "./coupon.page.html",
  styleUrls: ["./coupon.page.scss"],
})
export class CouponPage implements OnInit {
  @Input() salon_id: any;
  data: any = [];
  discount: any;
  code: any;
  coupon_id: any;
  type: any;
  slider: any = [];
  language: any;
  constructor(
    private api: ApiService,
    private util: UtilserviceService,
    private modal: ModalController,
    private translate: TranslateService,
    private nav: NavigationService
  ) { }
  ngOnInit() {
    this.language = localStorage.getItem("lan");

    this.api.get(jhcassoAPIUri.offers).subscribe(
      (success: any) => {
        if (success.success) {
          this.slider = success.data;

          
        }
      },
      (err) => {
        
      }
    );
    const data = {
      salon_id: localStorage.getItem("SalonId"),
    };
    this.api.get(jhcassoAPIUri.coupons).subscribe(
      (response: CouponsInfoResponse) => {
        if (response.status) {
          this.data = response.data;

          this.data.forEach((element) => {
            this.discount = element.discount;
            this.code = element.code;
            this.coupon_id = element.coupon_id;
            this.type = element.type;

            
          });
        }
      },
      (error) => {
        
      }
    );
  }

  apply(c) {
    const data = {
      code: c.code,
    };
    this.api.postDataWithToken(jhcassoAPIUri.checkcoupon, data, 'V1').subscribe(
      (success: any) => {
        if (success.success == true) {


          const lan = localStorage.getItem("lan");
          if (lan == "en") {
            this.util.presentToast("Coupon Successfully Applied");
          } else if (lan == "ar") {
            this.util.presentToast("تم تطبيق القسيمة بنجاح");
          } else {
            this.util.presentToast("Cuponul a fost aplicat cu succes");
          }
          if (success.success == true) {
            this.modal.dismiss({
              dis: c.discount,
              coupon: c.coupon_id,
              type: c.type,
              min_discount_amount: c.min_discount_amount,
            });
            
          }
          
        } else {
          const lan = localStorage.getItem("lan");
          if (lan == "en") {
            this.util.presentToast("this coupen is expire");
          } else if (lan == "ar") {
            this.util.presentToast("تنتهي صلاحية هذه القسيمة");
          } else {
            this.util.presentToast("acest cupen expiră");
          }
          this.modal.dismiss();
          
        }
      },
      (error) => {
        
      }
    );
  }

  backs() {
    this.modal.dismiss();
    this.nav.makePayment();
  }
}
